/**
 * This is the script to handle the sticky header and sticky social media icons.
 */
jQuery( window ).on( 'load', function() {

	var $window = $( window );
	var width = null;


	/**
	 * Functions for determining mobile window width
	 */

	// Get the width of the viewport
	function window_width() {
		// If it's already calculated, just return it
		if ( width ) { return width; }

		// Temporarily remove the scrollbar for an accurate width reading
		document.body.style.overflow = "hidden";
		width = $( window ).width();
		document.body.style.overflow = "";
		return width;
	}
	window_width(); // Calculate it once on first load

	jQuery( window ).on( 'resize', debounce( function() {
		width = null;    // Reset width
		window_width();  // Recalculate width
	}, 100 ) );

	// Function to determine if is_mobile
	function is_mobile() {
		return ( window_width() < 960 )
			|| jQuery( body ).hasClass( 'view-as-mobile' )
			|| jQuery( body ).hasClass( 'view-as-tablet' );
	}
	

	/**
	 * Sticky header
	 */
	var $body = jQuery( 'body' );
	var $menu_toggle = jQuery( '.menu-toggle' ).first();

	var sticky_pos = 15; // At what position does the header become sticky?

	// Initial load:
	if ( $window.scrollTop() >= sticky_pos ) { $body.addClass( 'sticky-header' ); }

	// Scroll event handler
	window.addEventListener( 'debounceScroll', function( event ) {
		if ( ! $body.hasClass( 'sticky-header' ) && $window.scrollTop() >= sticky_pos ) {
			$body.addClass( 'sticky-header' );
		} else if ( $body.hasClass( 'sticky-header' ) && $window.scrollTop() < sticky_pos ) {
			$body.removeClass( 'sticky-header' );
		}
	}, false );

	/**
	 * Hide fixed header when scrolling down in mobile, but show when scrolling up
	 *
	 * Putting this on a scroll event to be smoother.
	 */
	var last_scroll_pos = 0;
	var delay_hide = null;  // Timeout for hiding the sticky header in mobile
	var scrollDown = 0;

	window.addEventListener( 'scroll', function( event ) {
		// Are we scrolling down?
		scrollDown = ($window.scrollTop() > last_scroll_pos) && $window.scrollTop() > 160;
		last_scroll_pos = $window.scrollTop(); // Save for next time

		// If we are scrolling up, don't hide the header
		if ( ! scrollDown ) {
			$body.removeClass( 'sticky-header--hide' );  // Remove hide class
			clearTimeout( delay_hide );
			delay_hide = null;  // Reset hide timer
			return; // Nothing more to do
		}

		// If timer is already set, do nothing.
		if ( delay_hide ) { return; }

		// If already hidden, do nothing.
		if ( $body.hasClass( 'sticky-header--hide' ) ) { return; }

		// Start the timer:
		delay_hide = setTimeout( function( event ) {
			$body.addClass( 'sticky-header--hide' );
			delay_hide = null;
		}, 500 );
	}, false);



	/**
	 * Sticky header/footer
	 *
	 * NOTE: Currently the footer is no longer sticky.
	 */

	/**
	 * Detect if an elements position is fixed or not
	 *
	 * @see https://stackoverflow.com/questions/19474320/detect-whether-an-element-has-positionfixed-possibly-by-parent-element-via-jq
	 */
	$.fn.isfixed = function(){
		var el = this[0];
		while (typeof el === 'object' && el.nodeName.toLowerCase() !== 'body') {
		if (window.getComputedStyle(el).getPropertyValue('position').toLowerCase() === 'fixed') return true;
			el = el.parentElement;
		}
		return false;
	};

	// ---- Set body's margin-top to height of header on load ----
	function checkWindowWidth() {
		// Tablet view
		if ( $( '#site-header' ).isfixed() && window.innerWidth > 767 && window.innerWidth < 960 ) {		
			$( 'body' ).css( 'margin-top', $( '#site-header' ).height() - 7  + 'px' );

		// Mobile view	
		} else if ( $( '#site-header' ).isfixed() && window.innerWidth < 768 ) {		
			$( 'body' ).css( 'margin-top', $( '#site-header' ).height() - 3 + 'px' );		

		// Desktop
		} else if ( $( '#site-header' ).isfixed() && window.innerWidth > 767 ) {
			// Using site-header__navigation element for proper height
			$( 'body' ).css( 'margin-top', $( '#site-header__navigation' ).outerHeight() + 'px' );

		// Not sticky
		}  else {
			$( 'body' ).css( 'margin-top', '0px' );
		}
	}

	// Run Function
	checkWindowWidth();

	// Do the above tests on every resize
	$( window ).on( "resize", debounce( function() {
		checkWindowWidth();
	}, 100 ) );
	
});